<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.arfeType" clearable @change="partserch"
                        placeholder="请选择类型" style="width: 180px;">
                        <el-option label="权益金扣减" :value="1"></el-option>
                        <el-option label="权益金回退" :value="2"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.arfeStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 150px">
                        <el-option label="待处理" :value="1"></el-option>
                        <el-option label="已处理" :value="2"></el-option>
                        <el-option label="处理失败" :value="3"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 详情弹框 -->
            <el-dialog title="错误详情" :visible.sync="dialogDetail" width="60%" :before-close="handleDetailClose">
                <div class="detail-container">
                    <table class="detail-table">
                        <tr>
                            <td class="label">类型</td>
                            <td>{{ detailData.arfeType == 1 ? '权益金扣减' : '权益金回退' }}</td>
                            <td class="label">状态</td>
                            <td>
                                <el-tag :type="detailData.arfeStatus == 1 ? 'warning' : detailData.arfeStatus == 2 ? 'success' : 'danger'" size="small">
                                    {{ detailData.arfeStatus == 1 ? '待处理' : detailData.arfeStatus == 2 ? '已处理' : '处理失败' }}
                                </el-tag>
                            </td>
                        </tr>
                        <tr>
                            <td class="label">操作内容</td>
                            <td colspan="3">{{ detailData.arfeMsg }}</td>
                        </tr>
                        <tr>
                            <td class="label">错误信息</td>
                            <td colspan="3" class="error-text">{{ detailData.arfeError }}</td>
                        </tr>
                        <tr>
                            <td class="label">状态描述</td>
                            <td colspan="3">{{ detailData.arfeStatusDes }}</td>
                        </tr>
                        <tr>
                            <td class="label">创建时间</td>
                            <td>{{ detailData.createtime }}</td>
                            <td class="label">处理人</td>
                            <td>{{ detailData.handlerUserName }}</td>
                        </tr>
                        <tr>
                            <td class="label">处理时间</td>
                            <td colspan="3">{{ detailData.handlerUserTime }}</td>
                        </tr>
                    </table>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getAjefRightsFundErrorList
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            dialogDetail: false,
            detailData: {},
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "arfeType",
                    key: "arfeType",
                    title: "类型",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfeType == 1 ? '权益金扣减' : '权益金回退';
                    },
                },
                {
                    field: "arfeMsg",
                    key: "arfeMsg",
                    title: "操作内容",
                    align: "center",
                    width: 250,
                },
                {
                    field: "arfeError",
                    key: "arfeError",
                    title: "错误信息",
                    align: "center",
                    width: 300,
                },
                {
                    field: "arfeStatus",
                    key: "arfeStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfeStatus == 1 ? <el-tag type="warning">待处理</el-tag> : row.arfeStatus == 2 ? <el-tag type="success">已处理</el-tag> : <el-tag type="danger">处理失败</el-tag>;
                    },
                },
                {
                    field: "arfeStatusDes",
                    key: "arfeStatusDes",
                    title: "状态描述",
                    align: "center",
                    width: 150,
                },
                { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
                { field: "handlerUserName", key: "handlerUserName", title: "处理人", width: 100, align: "center" },
                { field: "handlerUserTime", key: "handlerUserTime", title: "处理时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #409EFF"
                                    on-click={() => {
                                        this.showDetail(row);
                                    }}
                                >
                                    详情
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = val - 200 - val * 0.04;
            });
        },
    },
    deactivated() {},
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() {},
    methods: {
        handleDetailClose() {
            this.dialogDetail = false;
            this.detailData = {};
        },
        showDetail(row) {
            this.detailData = row;
            this.dialogDetail = true;
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefRightsFundErrorList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefRightsFundErrorList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefRightsFundErrorList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.detail-container {
    padding: 10px;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.detail-table tr {
    border-bottom: 1px solid #eee;
}

.detail-table tr:last-child {
    border-bottom: none;
}

.detail-table td {
    padding: 12px 10px;
    line-height: 1.5;
}

.detail-table td.label {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 500;
    width: 100px;
    text-align: right;
}

.detail-table td.error-text {
    color: #f56c6c;
}
</style>
